import React, { useEffect, useCallback, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Wrench, RefreshCw, LogOut } from 'lucide-react';

const API = process.env.REACT_APP_API_URL || 'https://api-pak.sudindikjt2.site';
export default function MaintenanceOverlay() {
  const location = useLocation(), navigate = useNavigate();
  const [state, setState] = useState({ enabled:false, blocked:false, message:'' });
  const [checking, setChecking] = useState(false);
  const teacher = localStorage.getItem('userRole') === 'guru' && Boolean(localStorage.getItem('token'));
  const check = useCallback(async () => {
    if (!teacher) { setState({enabled:false,blocked:false,message:''}); return; }
    setChecking(true);
    try {
      const controller=new AbortController(), stop=setTimeout(()=>controller.abort(),7000);
      let response;
      try {
        response=await fetch(`${API}/api/maintenance/status`,{
          cache:'no-store',signal:controller.signal,
          headers:{Authorization:`Bearer ${localStorage.getItem('token')||''}`}
        });
      } finally {clearTimeout(stop);}
      if(!response.ok)throw new Error('Server tidak merespons');
      const data=await response.json();
      const enabled=data.enabled===true;
      // Backwards compatible during backend restart: old endpoint has no "blocked".
      const blocked=enabled&&(data.blocked===undefined || data.blocked===true);
      setState({enabled,blocked,message:String(data.message||'')});
    }catch(_){ /* Keep previous status; the backend enforces access. */ }
    finally{setChecking(false);}
  },[teacher]);
  useEffect(()=>{
    check();const timer=setInterval(check,10000);
    const onFocus=()=>check();window.addEventListener('focus',onFocus);
    return()=>{clearInterval(timer);window.removeEventListener('focus',onFocus);};
  },[check,location.pathname]);
  if(!teacher||!state.blocked)return null;
  return (
    <div className="fixed inset-0 z-[99999] bg-slate-900/80 backdrop-blur-sm flex items-center justify-center p-4" role="dialog" aria-modal="true" aria-label="Pemeliharaan SIPAK">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-lg p-7 md:p-10 text-center space-y-5">
        <div className="mx-auto w-16 h-16 flex items-center justify-center rounded-full bg-amber-100 text-amber-700"><Wrench size={32}/></div>
        <h1 className="text-2xl md:text-3xl font-bold text-slate-900">SIPAK Sedang Pemeliharaan</h1>
        <p className="text-lg text-slate-700 leading-relaxed">{state.message||'Sistem sedang diperbaiki. Mohon coba lagi beberapa saat.'}</p>
        <p className="text-sm text-slate-500">Bapak/Ibu tidak perlu mengirim ulang berkas. Halaman akan kembali dapat digunakan setelah pemeliharaan selesai.</p>
        <div className="flex flex-wrap justify-center gap-3 pt-2">
          <button type="button" onClick={check} disabled={checking} className="rounded-xl bg-blue-700 hover:bg-blue-800 disabled:opacity-60 text-white px-5 py-3 font-semibold inline-flex items-center gap-2"><RefreshCw size={18}/>{checking?'Memeriksa...':'Cek lagi'}</button>
          <button type="button" onClick={()=>{localStorage.removeItem('token');localStorage.removeItem('userRole');localStorage.removeItem('userName');navigate('/');}} className="rounded-xl border border-slate-300 px-5 py-3 font-semibold inline-flex items-center gap-2"><LogOut size={18}/>Keluar</button>
        </div>
      </div>
    </div>
  );
}
